"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _portal = _interopRequireDefault(require("@eig-builder/core-utils/portal"));

var _runtimeConfigHelper = require("@eig-builder/core-utils/helpers/runtime-config-helper");

var _Skeleton = _interopRequireDefault(require("@eig-builder/core-ui/Skeleton"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  flex-grow: 1;\n  margin-left: 15px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  height: 50px;\n  width: 50px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n  height: 100%;\n  width: 250px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var SkeletonContainer = _styledComponents["default"].div(_templateObject());

var SkeletonImage = (0, _styledComponents["default"])(_Skeleton["default"]).attrs({
  variant: 'circle'
})(_templateObject2());
var SkeletonText = (0, _styledComponents["default"])(_Skeleton["default"]).attrs({
  variant: 'rect'
})(_templateObject3());

var SkeletonSelector = function SkeletonSelector() {
  return /*#__PURE__*/_react["default"].createElement(_portal["default"], {
    elementId: "header-root"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _runtimeConfigHelper.getRuntimeConfig)()._app,
    style: {
      height: '100%'
    }
  }, /*#__PURE__*/_react["default"].createElement(SkeletonContainer, null, /*#__PURE__*/_react["default"].createElement(SkeletonImage, null), /*#__PURE__*/_react["default"].createElement(SkeletonText, null))));
};

var _default = SkeletonSelector;
exports["default"] = _default;